"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SdsToastStateService = exports.AUTO_CLOSE_DELAY_MS = void 0;
var _inversify = require("inversify");
var _sdsToastStateServiceDiKeys = require("./sdsToastStateServiceDiKeys");
var _dec, _dec2, _dec3, _dec4, _class;
// From https://sheribyrnehaber.medium.com/designing-toast-messages-for-accessibility-fb610ac364be
//
// A good length of time to keep messages up is 5 seconds plus 1 extra second for every 120 words,
// rounding up. This is how fast the average American reads. That means the shortest default that
// should be used as a best practice is 6 seconds.
//
// We'll go with 7 to be safe.
const AUTO_CLOSE_DELAY_MS = 7000;
exports.AUTO_CLOSE_DELAY_MS = AUTO_CLOSE_DELAY_MS;
let SdsToastStateService = (_dec = (0, _inversify.injectable)(), _dec2 = function (target, key) {
  return (0, _inversify.inject)(_sdsToastStateServiceDiKeys.sdsToastDataClientDIKey)(target, undefined, 0);
}, _dec3 = Reflect.metadata("design:type", Function), _dec4 = Reflect.metadata("design:paramtypes", [typeof ToastManager === "undefined" ? Object : ToastManager]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = class SdsToastStateService {
  constructor(toastManager) {
    this.toastManager = toastManager;
  }
  createSimpleToast = args => {
    this.toastManager.createSimpleToast(args);
  };
  createSimpleToastWithTheme = args => {
    this.toastManager.createSimpleToastWithTheme(args);
  };
  requestInteractiveToast = args => {
    return this.toastManager.requestInteractiveToast(args);
  };

  /**
   * Called by the code that wants to be responsible for rendering toasts. The provided callbacks
   * will be called with the contents of the current toast stack.
   *
   * Returns an object with functions to control the stack.
   */
  registerToaster = args => {
    return this.toastManager.registerToaster(args);
  };

  /**
   * Call to restart the auto-remove timers for any toasts currently in the "entered"
   * state. This should be called when the user stops interacting with the toast stack.
   */
  restartAutoRemove = () => {
    this.toastManager.restartAutoRemove();
  };

  /**
   * Call to pause the auto-remove timers for any toasts currently in the "entered"
   * state. This should be called when the user starts interacting with the toast stack.
   */
  pauseAutoRemove = () => {
    this.toastManager.pauseAutoRemove();
  };
}) || _class) || _class) || _class) || _class);
exports.SdsToastStateService = SdsToastStateService;
//# sourceMappingURL=SdsToastStateService.js.map